import React from 'react';
import { Row, Col, Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import SalesFilter, { SalesFilterProps } from './SalesFilter';

export type Props = SalesFilterProps;
const SalesReportHeader: React.FC<Props> = ({
  categories,
  handleCategoriesFilterChange,
}) => (
  <Row css="padding: 1em 1.2em">
    <Col span={4}>
      <h3 css="padding-left: 8px;margin: 0; line-height: 2em;">
        <FormattedMessage defaultMessage="Bestseller" />
      </h3>
    </Col>
    <Col span={20} css=" display: flex; justify-content: flex-end;">
      <Space size="middle">
        <SalesFilter
          handleCategoriesFilterChange={handleCategoriesFilterChange}
          categories={categories}
        />
      </Space>
    </Col>
  </Row>
);

export default SalesReportHeader;
